import React from "react";

import styles from "./Paragraph.module.scss";

const Paragraph = ({ title, content, titleStyle,  contentStyle }) => {
  return (
    <div className={styles["content-section"]}>
      <h2 className={styles.title} style={titleStyle} >
        {title}
      </h2>
      {content.map((paragraph, index) => (
        <p key={index} className={styles.content} style={contentStyle}>
          {paragraph}
        </p>
      ))}
    </div>
  );
};

export default Paragraph;
